import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'leimmaDot';
const args = {};

export class LeimmaDot extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
